export default {"src":"/_next/static/media/room-lets-icon-selected.ca321b09.svg","height":77,"width":86,"blurWidth":0,"blurHeight":0};